import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslationService } from '../shared/translation.service';

/**
 * @title Dialog Overview
 */
@Component({
  selector: 'hc-info-dialog',
  template:
  `
     <div fxLayout="column" style="height: 150px; padding: 15px">
           <p fxFlex>
               {{ displayMessage }}
           </p>
           <div fxFlex="none"  fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="space-around center">
               <button mat-raised-button color="primary" (click)="clickOk()" >{{ 'admin.web.ok' | trans }}</button>
           </div>
     </div>
      `
})

export class InfoDialogComponent {

    public displayMessage: string;

  constructor(
    public dialogRef: MatDialogRef<InfoDialogComponent>,
        private trans: TranslationService,
        @Inject(MAT_DIALOG_DATA) public message: string) {
            // If we receive a translation key, translate it; otherwise treat as literal text.
            const looksLikeKey = typeof message === 'string'
                && /^[a-z0-9_.-]+$/i.test(message)
                && message.indexOf('.') > -1;

            this.displayMessage = looksLikeKey ? this.trans.instant(message) : message;
        }

    clickOk(): void {
        this.dialogRef.close(true);
    }
}
